<template>
	<div class="general-page">
		<background :src="config.bg" :mobileSrc="config.mobileBg" />
		<div class="page-contents">
			<div class="data-driven-agenda-wrapper text-center" v-bind:style="wrapperStyle()">
				<div class="title" v-bind:style="titleStyle()">
					{{ text.getByKey("title", { default: "Agenda", en: "Agenda", fr: "Agenda" }) }}
				</div>
				<br />
				<arbitrary-data-as-agenda
					v-if="mounted"
					v-bind:agendaSource="config.agendaSource"
					v-bind:speakerSource="config.speakerSource"
					v-bind:searchOn="config.searchOn"
					v-bind:analyticsContext="analyticsContext"
					v-bind:calendarTypes="config.calendarTypes"
					:agendaStyle="agendaStyle()"
					:calendarStyle="calendarStyle()"
					:text="text.shiftContext('arbitraryDataAsAgenda')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Background from "../components/Background";
import ArbitraryDataAsAgenda from "../components/ArbitraryDataAsAgenda";
export default {
	name: "DataDriveAgendaPage",
	props: {
		config: Object,
		common: Object,
		analyticsContext: Object,
		languageContextLocation: Array
	},
	data: () => {
		return {
			mounted: false
		};
	},
	components: { Background, ArbitraryDataAsAgenda },
	inject: ["textService"],
	computed: {
		text() {
			// This component can be accessed via a route or directly from another component
			// When accessed from another component, it passes in the textservice with the appropriate context (for global text definitions)
			// else this service uses the route and from the root global context.
			if (this.languageContextLocation) {
				return this.textService.copy(this.config.text, this.languageContextLocation);
			} else {
				return this.textService.copy(this.config.text, ["root", this.$route.name]);
			}
		}
	},
	mounted() {
		// Need to wait until mounted is called so that analyticsContext property is initialized and available to be passed to the arbitrary data as agenda element
		this.mounted = true;
	},
	methods: {
		titleStyle() {
			let style = this.config.style?.title;
			let rc = {};
			if (style) {
				rc = Object.assign(rc, style);
			}
			return rc;
		},
		agendaStyle() {
			let style = this.config.style?.agenda;
			let rc = {
				group: { height: "600px" },
				groupHeader: {
					color: this.common.globalStyleVariables["primary-text-colour"],
					backgroundColor: this.common.globalStyleVariables["primary-colour"]
				}
			};
			if (style) {
				rc = Object.assign(rc, style);
			}
			return rc;
		},
		calendarStyle() {
			// add to calendar uses old scheme for style override and doesn't have a "predefined element"
			let rc = { "primary-colour": "white", "secondary-colour": "white" };
			let style = this.config.style?.agendaCalendar;
			if (style) {
				rc = Object.assign(rc, style);
			}
			return rc;
		},
		wrapperStyle() {
			let rc = { top: "0px", "max-width": "95%" };
			let style = this.config.style?.wrapper;
			if (style) {
				rc = Object.assign(rc, style);
			}
			return rc;
		}
	}
};
</script>

<style lang="scss" scoped>
@import "../scss/constants";

.page-contents {
	padding: 80px 80px 80px;
	@media (max-width: $screen-tablet-max) {
		padding: 80px 20px 20px;
	}
	@media (max-width: $screen-mobile-max) {
		padding: 80px 20px 20px;
	}
}

// Ryan: My preference is to make this 100% width & height
.data-driven-agenda-wrapper {
	font-size: small;
	min-width: unset;
	min-width: auto;
	// horizontal centering
	margin: 0px auto;
	position: relative;

	// min-width: var(--min-width);
	// max-width: var(--max-width);
	//height: var(--height);
	// top: var(--top);
	padding: 10px;

	.title {
		font-size: xx-large;
		color: black;
		display: block;
		margin: 0 auto;
		width: 95%;
	}
}

@media (max-width: $screen-mobile-max) {
	.data-driven-agenda-wrapper {
		min-width: unset;
		max-width: 95%;

		min-width: auto;
	}
}
</style>
